import { Phone, Lightning, UsersThree } from "@phosphor-icons/react";
import PhoneInput from "../../../ui/PhoneInput";
import PatientSearchSelect from "../PatientSearchSelect";

/**
 * Step 1 — patient selection: searchable list, temp-customer path (when the
 * clinic enabled it), multi-therapist override for single appointments.
 */
function PatientStep({ form }) {
  const {
    patients,
    formData,
    selectPatient,
    updateField,
    stepErrors,
    tempCustomersEnabled,
    isMultiTherapistPatient,
    selectedPatientTherapistIds,
    clinicTherapists,
    appointmentTherapistId,
    setAppointmentTherapistId,
    selectedPatient,
    fastPathReady,
    goToSummaryFastPath,
  } = form;

  return (
    <div className="apt-wiz-step-panel" key="step-patient">
      {/* Patient can't change on an existing appointment (same as the classic modal) */}
      {!form.isEditing && (
        <PatientSearchSelect
          patients={patients}
          selectedPatientId={formData.patientId}
          isTempCustomer={formData.isTempCustomer}
          isBlockedTime={formData.isBlockedTime}
          tempCustomersEnabled={tempCustomersEnabled}
          onSelect={selectPatient}
          error={stepErrors.patientId}
        />
      )}

      {selectedPatient && (
        <div className="apt-wiz-selected-card">
          <div className="apt-wiz-selected-name">{formData.patientName}</div>
          {(selectedPatient.phone || selectedPatient.mobilePhone) && (
            <div className="apt-wiz-selected-phone">
              <Phone size={12} weight="fill" />
              <span dir="ltr">{selectedPatient.phone || selectedPatient.mobilePhone}</span>
            </div>
          )}
        </div>
      )}

      {formData.isTempCustomer && (
        <div className="apt-wiz-temp-fields">
          <div className="apt-wiz-form-group">
            <label>שם הלקוח</label>
            <input
              type="text"
              value={formData.patientName}
              onChange={(e) => updateField("patientName", e.target.value)}
              placeholder="שם מלא"
              className={stepErrors.tempCustomerName ? "has-error" : ""}
            />
            {stepErrors.tempCustomerName && (
              <div className="apt-wiz-field-error">{stepErrors.tempCustomerName}</div>
            )}
          </div>
          <div className="apt-wiz-form-group">
            <label>נייד</label>
            <PhoneInput
              value={formData.tempCustomerPhone}
              onChange={(value) => updateField("tempCustomerPhone", value || "")}
              error={stepErrors.tempCustomerPhone}
            />
            {stepErrors.tempCustomerPhone && (
              <div className="apt-wiz-field-error">{stepErrors.tempCustomerPhone}</div>
            )}
          </div>
        </div>
      )}

      {isMultiTherapistPatient && !formData.isRecurring && !form.isEditing && (
        <div className="apt-wiz-form-group">
          <label>
            <UsersThree size={13} weight="fill" /> מטפל/ת אחראי/ת לפגישה
          </label>
          <select
            value={appointmentTherapistId}
            onChange={(e) => setAppointmentTherapistId(e.target.value)}
          >
            {selectedPatientTherapistIds.map((tid) => {
              const t = clinicTherapists.find((ct) => ct.uid === tid);
              return (
                <option key={tid} value={tid}>
                  {t ? `${t.firstName} ${t.lastName}` : tid}
                </option>
              );
            })}
          </select>
        </div>
      )}

      {fastPathReady && (
        <button
          type="button"
          className="apt-wiz-fastpath-btn"
          onClick={goToSummaryFastPath}
        >
          <Lightning size={15} weight="fill" />
          הכל מוכן — מעבר לסיכום
        </button>
      )}
    </div>
  );
}

export default PatientStep;
